import { render, staticRenderFns } from "./CoursesCreateDetail.vue?vue&type=template&id=364cebf1"
import script from "./CoursesCreateDetail.vue?vue&type=script&lang=js"
export * from "./CoursesCreateDetail.vue?vue&type=script&lang=js"
import style0 from "./CoursesCreateDetail.vue?vue&type=style&index=0&id=364cebf1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports